<template>
  <div class="cash">
    <slot name="date"></slot>
    <div class="index-back" @click="$emit('gotoGame')">
      <img src="@this/assets/image-32.png" />
    </div>
    <div class="cash-box">
      <div class="cash-money">
        <div class="cash-time" :class="{ no: cashStatus == 3 }">
          <div v-if="cashStatus !== 3">开奖时间：22：00：00</div>
          <div v-else>很遗憾,本期未中奖~</div>
        </div>
        <div class="cash-type">
          <div v-if="cashStatus == 1">{{ currentSeckill.dateFormat2 }}开始</div>
          <div v-if="cashStatus == 2">等待开奖</div>
          <div v-if="cashStatus == 3">已开奖</div>
        </div>
      </div>
      <div class="cash-remark">
        <div class="cash-name" v-for="(item, index) in cashList" :key="index">
          <div class="cash-user">{{ item }}</div>
          <div class="cash-join">已参加</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cashList: {
      type: Array,
      default() {
        return [];
      },
    },
    cashStatus: {
      type: Number,
      default: 0,
    },
    currentSeckill: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.cash {
  background: linear-gradient(to bottom, #ffb991, #ffdfcd);
  width: 100vw;
  height: 100vh;
  position: relative;
}
.index-back {
  position: absolute;
  top: 100px;
  left: 30px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffc3a1;
  border-radius: 50%;
  border: 1px solid #f55d30;
  img {
    width: 34px;
    height: 32px;
  }
}
.cash-box {
  position: relative;
  .cash-money {
    background: url(~@this/assets/image-61.png) no-repeat;
    background-size: 100% 100%;
    width: 541px;
    height: 487px;
    position: absolute;
    top: 180px;
    left: 100px;
    .cash-time {
      position: absolute;
      top: 310px;
      left: 125px;
      color: #fce9e6;
      &.no {
        left: 145px;
      }
    }
    .cash-type {
      position: absolute;
      top: 420px;
      left: 140px;
      font-size: 30px;
      color: #e04b22;
      font-weight: 800;
      width: 260px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .cash-remark {
    background: url(~@this/assets/image-62.png) no-repeat;
    background-size: 100% 100%;
    width: 277px;
    height: 497px;
    position: absolute;
    right: 100px;
    top: 150px;
    padding: 20px 60px;
    .cash-name {
      border-bottom: 1px solid #ffdcc9;
      height: 100px;
      line-height: 100px;
      display: flex;
      font-size: 30px;
      font-weight: 800;
      .cash-user {
        margin-right: 20px;
      }
      .cash-join {
      }
    }
  }
}
</style>
